import React, { useEffect, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import copy from "copy-to-clipboard";
import { useTranslation } from "react-i18next";

import ReactTost from "../../ReactTost";
import { useParams } from "react-router";

const ChatBotEmbed = (props) => {

  const [shareUrl, setShareUrl] = useState("");
  const { t } = useTranslation();
  const { bot} = useParams();
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [changeIcon, setChangeIcon] = useState(false);
  const [changeIconData, setchangeIconData] = useState(false);

  useEffect(() => {
    if (bot) {
      setShareUrl(`${process.env.REACT_APP_URL}/public-chatbot/${bot}`);
    }
  }, [bot]);
  const codeSnippetScript = `<script src="${process.env.REACT_APP_API_URL}/v1/bot/script/${bot}" defer></script>`;
  function CopyData(e) {
    e.preventDefault();
    copy(shareUrl);
    setChangeIcon(true);
    setTimeout(() => {
      setChangeIcon(false)
    }, 2000);
  }

  function CopyScript(e) {
    e.preventDefault();
    copy(codeSnippetScript);
    setchangeIconData(true);
    setTimeout(() => {
      setchangeIconData(false)
    }, 2000);
  }
  // Share URL
  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      <section className="embed_box">
        <Container>
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="embed_wrap">
                <h2>{t("Embed on site")}</h2>

                <div className="codewrap">

                  <hr className="my-5" />
                  <h4>{t("Script")}</h4>
                  <div className="code_content">
                    <span>
                      {t("To add a chat bubble to the bottom right of your website add this script tag to your html")}
                    </span>
                    <Button
                      className="button_copy"
                      variant="danger"
                      onClick={(e) => {
                        CopyScript(e);
                      }}
                    >
                      {t("Copy")} {changeIconData ? <i className="fa-solid fa-check"></i> : <i className="fa-regular fa-copy"></i>}
                    </Button>
                  </div>
                  <div className="code_box">
                    <code>{codeSnippetScript}</code>
                  </div>
                  <hr className="my-5" />
                  <h4>{t("Share chatbot")}</h4>
                  <div className="code_content">
                    <p>{t("If you share this link, anybody can access your chatbot, independent from the private or public mode under settings. If you want to show your bot on your website, please use embeddings with iframe or with javascript.")}</p>
                    <Button
                      className="button_copy"
                      variant="danger"
                      onClick={(e) => {
                        CopyData(e);
                      }}
                    >
                      {t("Copy")} {changeIcon ? <i className="fa-solid fa-check"></i> : <i className="fa-regular fa-copy"></i>}
                    </Button>
                  </div>
                  <div className="code_box">
                    <code>{shareUrl}</code>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChatBotEmbed;
